/**
 * Configurações do ambiente de produção
 * yarn build:prod
 */
const prodConfig = {
  env: "prod",
  hosts: {
    auth: "https://api.sefaz.rn.gov.br/autbasic/",
    cadastros: "https://api.sefaz.rn.gov.br/cadastros/",
    fiscalizacao: "https://api.sefaz.rn.gov.br/fiscalizacao/",
    usuarios: "https://api.sefaz.rn.gov.br/usuarios/",
    extratofiscal: "https://api.sefaz.rn.gov.br/extrato/",
    nfp: "https://api.sefaz.rn.gov.br/nfp/",
  },
};

export default prodConfig;
